import React, { Component } from "react";
import { Grid, Row, Col, Modal, Dropdown } from "react-bootstrap";

import "./HSGMessage.css";
import Constants from "../../../Phi/Constants";
import moment from "moment";

import Avatar from "react-avatar";

import NotificationBadge from "react-notification-badge";
import { Effect } from "react-notification-badge";


class HSGMessages extends Component {
    constructor(props) {
        super(props);
        this.state = {

            defaultChatLimit: 500,
            defaultChatOffset: 0,

            defaultMessageLimit: 50,
            defaultMessageOffset: 0,

            currentChatInfo: null,

            inNewMessage: '',

            currentChatArray: [0],
            currentChatIndex: 0
        };
    }

    // componentWillMount() {

    // }

    componentDidMount() {
        this.props.fetchChats(this.props.currentUserId, this.state.defaultChatLimit, this.state.defaultChatOffset)
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.messageFrom && this.props.messageFrom !== nextProps.messageFrom) {
            this.props.fetchChats(
                nextProps.messageFrom, 
                this.state.defaultChatLimit, 
                this.state.defaultChatOffset
            )   
        }

        if(this.props.messageTo !== nextProps.messageTo || this.props.messageRef !== nextProps.messageRef) {
            // this.props.fetchMessages(
            //     nextProps.messageFrom, 
            //     nextProps.messageTo, nextProps.messageRef, 
            //     this.state.defaultMessageLimit,
            //     this.state.defaultMessageOffset
            // )
        }

        if(this.props.chats !== nextProps.chats && nextProps.chats && nextProps.chats.length && !!!nextProps.message) {
            let chat = nextProps.chats[0]
            this.setState({currentChatInfo: JSON.parse(chat.info)[0]})
            this.props.fetchMessages(
                nextProps.currentUserId, 
                chat.messageTo, 
                chat.messageRef, 
                this.state.defaultMessageLimit,
                this.state.defaultMessageOffset
            )
        }

    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.messages !== this.props.messages){
            this.scrollToBottom()
        }
    }

    getDaysPassed = time => {
        let millis = new Date().getTime() - new Date(time).getTime()

        let seconds = Math.floor(millis / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);
        let months = Math.floor(days / 30);
        let years = Math.floor(months / 12);

        return `${
            years
                ? `${years} ${years > 1 ? "Years" : "Year"}`
                : months
                ? `${months} ${months > 1 ? "Months" : "Month"}`
                : days
                ? `${days} ${days > 1 ? "Days" : "Day"}`
                : hours
                ? `${hours} ${hours > 1 ? "Hours" : "Hour"}`
                : minutes
                ? `${minutes} ${minutes > 1 ? "Minutes" : "Minute"}`
                : `${seconds} ${seconds > 1 ? "Seconds" : "Second"}`
        } ago`;
    };

    getDaysPassedV2 = time => {
        
        try {

            let seconds = parseInt(time.second)
            let minutes = parseInt(time.minute)
            let hours = parseInt(time.hour)
            let days = parseInt(time.day)
            let months = parseInt(time.month)
            let years = parseInt(time.year)

            return `${
                years
                    ? `${years} ${years > 1 ? "Years" : "Year"}`
                    : months
                    ? `${months} ${months > 1 ? "Months" : "Month"}`
                    : days
                    ? `${days} ${days > 1 ? "Days" : "Day"}`
                    : hours
                    ? `${hours} ${hours > 1 ? "Hours" : "Hour"}`
                    : minutes
                    ? `${minutes} ${minutes > 1 ? "Minutes" : "Minute"}`
                    : `${seconds} ${seconds > 1 ? "Seconds" : "Second"}`
            } ago`;

        }catch(e) {
            return ''
        }
    };

    getNameOfParentChild = (info) => (
        <div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-chat-parent-name no-padding-left-right">
                {info.toName}                                
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-chat-student-name no-padding-left-right">
                {info.refName}                   
            </div>
        </div>
    )

    getChatInfo = (info, onTop, pos) => (
        <div>
            <div className={
                    onTop ? 
                        "col-lg-1 col-md-1 col-sm-2 col-xs-2 no-padding-left-right align-center align-middle" :
                        "col-lg-2 col-md-2 col-sm-3 col-xs-3 no-padding-left-right align-center align-middle"
                }
            >   
                <Avatar name={info.toName} round={true} size={40} />
                {this.state.currentChatArray.includes(pos) || onTop ? null :<NotificationBadge
                    count={info.unreadCount}
                    effect={Effect.SCALE}
                    style={{ fontSize: 8, padding: 1 }}
                />}
            </div>

            <div className = {
                onTop ? 
                    "col-lg-11 col-md-11 col-sm-10 col-xs-10 no-padding-left-right" :
                    "col-lg-10 col-md-10 col-sm-9 col-xs-9 no-padding-left-right"
                }
            > 
                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8 no-padding-left-right">
                    {this.getNameOfParentChild(info)}
                </div>
                
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 hsg-message-chat-time hsg-message-side-right">
                    {/* {this.getDaysPassed(info.timeAgo)}                                 */}
                    {this.getDaysPassedV2(info.timeAgo)}
                    {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-chat-time hsg-message-side-right">
                    </div> */}
                </div>
            </div>

            <div>
                {
                    onTop ? 
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-ref-information-head">
                            {/* <span className="hsg-message-ref-information">{`HSG ID: ${info.refHsgId}`}</span> */}
                            <span className="hsg-message-ref-information">{`Admission Number: ${info.refAdmissionNumber}`}</span>
                            <span className="hsg-message-ref-information">{`Class: ${info.refClass}`}</span>
                            <span className="hsg-message-ref-information">{`Section: ${info.refSection}`}</span>

                        {/* <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                        
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                        
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                        
                        </div>    */}
                    </div> : null
                }
            </div>
        </div>
    )

    renderChats = (chats) => {

        return (
            chats && chats.length ? chats.map((chat, pos) => {

                let info = chat.info && JSON.parse(chat.info)[0] || null
                let position = pos === (this.state.currentChatIndex || 0)
                return (
                    info ? 
                    <div 
                        className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-chat-display no-padding-left-right ${position ? 'hsg-message-chat-high-lighted' : ''}`}
                        key={pos}
                        onClick={() => {
                            let currentChatArray = this.state.currentChatArray
                            currentChatArray.push(pos)
                            this.setState({currentChatInfo: info, currentChatIndex: pos, currentChatArray})
                            this.props.fetchMessages(
                                this.props.messageFrom, info.messageTo, info.messageRef, this.state.defaultMessageLimit, this.state.defaultMessageOffset
                            )
                            // this.props.fetchChats(this.props.messageFrom, this.state.defaultChatLimit, this.state.defaultChatOffset)
                        }} 
                    >

                        <div>
                            {this.getChatInfo(info, false, pos)}
                        </div>
                        
                        {/* <div className="row col-lg-10 col-md-10 col-sm-10 col-xs-10">
                            <div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {info.fromName}
                            </div>
                            <div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {info.refName}
                            </div>
                            <div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {this.getDaysPassed(info.createdTime)}
                            </div>
                        </div>
                        <div className="row col-lg-2 col-md-2 col-sm-2 col-xs-2">
                            <div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {info.unreadCount}
                            </div>
                        </div> */}

                        {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <hr />
                        </div> */}
                    </div> : null
                )
            }) : null
        )
    }

    renderMessages = (messages, messageFrom) => {

        return (
            messages && messages.length ? messages.map((message, index) => {
                let side = messageFrom === message.messageFrom ? 'hsg-message-side-right' : 'hsg-message-side-left'
                let backGround = messageFrom === message.messageFrom ? 'hsg-message-messages-side-right' : 'hsg-message-messages-side-left'
                let custom = JSON.parse(message.messageCustomJson)
                return (
                    <div className={side} key={index}>
                        <div className={`hsg-message-messages-display ${backGround}`}>
                            <div className="">
                                {custom.message}
                            </div>
                            <div className="hsg-message-sub-script" alt={message.timeAgo}>
                                {/* {this.getDaysPassed(message.timeAgo)} */}
                                {this.getDaysPassedV2(message.timeAgo ? JSON.parse(message.timeAgo) : {})}
                            </div>
                        </div>
                    </div>
                )
            }) : null
        )
    }

    renderInput = () => {
        const { props } = this

        return (
            <div className="no-padding-left-right" style={{display: "flex"}}>
                <div style={{width:'97%'}}>
                    <textarea
                        onChange={e => {
                            e.target.value !== this.state.inNewMessage && this.setState({ inNewMessage: e.target.value });
                        }}
                        placeholder="Type in the new message..."
                        className="hsg-message-new-message-box"
                        type="text"
                        value={this.state.inNewMessage || ""}
                        multiple
                    />
                </div>
                <div className="padding-10" style={{paddingTop: 26, cursor: "pointer"}} onClick={()=>{
                    this.state.inNewMessage ? 
                        this.props.sendMessage(props.messageFrom, props.messageTo, props.messageRef, {message: this.state.inNewMessage})
                        : null
                    this.setState({inNewMessage: ""})
                }}>
                    <span className="glyphicon glyphicon-send" style={{color: "#34bfa3"}}></span>
                </div>
            </div>
        )
    }

    renderNoDataMSG = (msg) => (
        <div className="hsg-msp-detail-empty">
                { msg ? msg : "No Data Available"}
        </div>
    )

    scrollToBottom = () => {
        var objDiv = document.getElementById("hsg-message-body-messages-1") || {};
        objDiv.scrollTop = objDiv.scrollHeight;
    }

    render() {
        const { props, state } = this;
        const dimensions = props.dim 
        // const height = dimensions && dimensions.height ? dimensions.height * 0.90 : 600  
        const height = 619
        
        return (
            <div className="container hsg-message-container">
                {
                    props.chats && props.chats.length ?
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="col-lg-4 col-lg-4 col-sm-4 col-xs-4 no-padding-left-right" style = {{marginBottom:100}}>
                            {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-head-box hsg-message-round-square">
                                MESSAGING
                            </div> */}
                            <div 
                                className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-body-box hsg-message-round-square no-padding-left-right"  
                                style={{height: height}}
                            >   
                                {this.renderChats(props.chats)}
                            </div>
                        </div>
                        {
                            props.messages && props.messages.length ?
                            <div className="col-lg-8 col-lg-8 col-sm-8 col-xs-8 no-padding-left-right" style={{height: height}}>
                                {
                                    this.state.currentChatInfo && 
                                        <div 
                                            className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-head-box hsg-message-round-square"
                                        >
                                            {/* {this.getNameOfParentChild(this.state.currentChatInfo || {})} */}
                                            {this.getChatInfo(this.state.currentChatInfo || {}, true)}
                                        </div>
                                }
                                <div 
                                    className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-body-box hsg-message-round-square no-padding-left-right"
                                    style={{height: 538}}
                                >   
                                    <div id="hsg-message-body-messages-1" className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-message-body-messages">
                                        {
                                            props.messages && props.messages.length 
                                                ? this.renderMessages(props.messages, props.messageFrom) 
                                                : this.renderNoDataMSG("No thing here!!!")
                                        }
                                    </div>

                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        {this.renderInput()}
                                    </div>
                                </div>
                            </div> : this.renderNoDataMSG("Nothing here!!!")
                        }
                    </div> : this.renderNoDataMSG("There are no messages!!!")
                }
            </div>
        );
    }
}

export default HSGMessages;



// WEBPACK FOOTER //
// ./src/Containers/MessageContainer/Component/HSGMessage.js